<template>
    <APPDownloadHomePage
        v-show="
            isShowHeader && isShowAppDownloadHome && displayHeaderDownloadIcon
        "
    ></APPDownloadHomePage>
    <div
        class="home-nav__match-wrapper full-screen-width"
        :class="{
            'home-nav__match-wrapper__app-download': isShowAppDownloadHome,
        }"
        v-show="isShowHeader"
    >
        <div class="container" style="overflow: visible">
            <div class="display-flex-sb py7">
                <div class="display-flex-center logo-wrapper">
                    <div class="home-nav__icon-wrapper">
                        <MainLogo class="home-logo"></MainLogo>
                    </div>
                </div>

                <div
                    class="aspn-home-nav__container"
                    :style="
                        !displayHeaderDownloadIcon
                            ? 'justify-content: left;'
                            : ''
                    "
                    v-if="!isMobile && !isLoginPage"
                >
                    <div
                        @click="handleClickTabBeforeRouter(o)"
                        class="aspn-home-nav__child relative"
                        :class="{
                            selected: o.selected,
                            'font-l': currentLocale === 'th',
                        }"
                        v-for="(o, index) in aspnHeaderTabs"
                        :key="index"
                    >
                        <div>
                            <span>{{ $t(o.name) }}</span>
                        </div>
                    </div>
                </div>
                <div
                    class="display-flex-center profile-icon-wrapper"
                    :class="{ 'header-right__wrapper': isMobile }"
                >
                    <!-- notification icon -->
                    <!-- <div class="notification-icon" v-if="!isMobile">
                        <div class="red-dot">9</div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_890_3255" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                            <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_890_3255)">
                            <path d="M5 19C4.71667 19 4.47917 18.9042 4.2875 18.7125C4.09583 18.5208 4 18.2833 4 18C4 17.7167 4.09583 17.4792 4.2875 17.2875C4.47917 17.0958 4.71667 17 5 17H6V10C6 8.61667 6.41667 7.3875 7.25 6.3125C8.08333 5.2375 9.16667 4.53333 10.5 4.2V3.5C10.5 3.08333 10.6458 2.72917 10.9375 2.4375C11.2292 2.14583 11.5833 2 12 2C12.4167 2 12.7708 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8333 4.53333 15.9167 5.2375 16.75 6.3125C17.5833 7.3875 18 8.61667 18 10V17H19C19.2833 17 19.5208 17.0958 19.7125 17.2875C19.9042 17.4792 20 17.7167 20 18C20 18.2833 19.9042 18.5208 19.7125 18.7125C19.5208 18.9042 19.2833 19 19 19H5ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM8 17H16V10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10V17Z" fill="#121416"/>
                            </g>
                        </svg>
                    </div> -->

                    <!-- Global Search -->
                    <div
                        v-if="isMobile"
                        class="display-flex"
                        @click="toggleGlobalSearchModal()"
                    >
                        <IconMode>
                            <template #default="{ index }">
                                <img
                                    src="@static/images/icons/aspn_icon/icon_search_webapp.png"
                                    v-if="index === 'lightWebapp'"
                                    class="search-icon-webapp"
                                />
                                <img
                                    src="@static/images/icons/aspn_icon/icon_search_webapp_dark.png"
                                    v-else-if="index === 'darkWebapp'"
                                    class="search-icon-webapp"
                                />
                            </template>
                        </IconMode>
                    </div>

                    <!-- mobile nav -->
                    <div class="mobile_nav_box" v-if="isMobile && false">
                        <router-link
                            :to="{ path: `/${currentLocale}${o.path}` }"
                            v-for="(o, index) in headerTabs"
                            :key="index"
                        >
                            <div v-if="o.selected">
                                <div class="display-flex-center">
                                    <span>{{ $t(o.name) }}</span>
                                    <HeaderMenuIcon
                                        :pathName="o.pathName"
                                        :selected="o.selected"
                                    ></HeaderMenuIcon>
                                </div>
                                <div v-if="o.isLive" class="dot-wrapper">
                                    <div class="ripple"></div>
                                </div>
                            </div>
                        </router-link>
                    </div>

                    <!-- Favourite -->
                    <!--  && currentSportType === 'football' -->
                    <!-- <div v-if="isMobile"  class="btn-fav-wrapper" @click="toggleFavouriteModal($event)">
                            <div class="btn-fav selected"></div>
                        </div> -->
                    <!-- <HeaderAppBanner v-show="!isMobile" /> -->
                    <!-- Notification -->
                    <!-- <div v-show="isShowNotification" class="display-flex-center header-notification-icon__wrapper">
                        <template v-if="isMobile">
                            <div class="header-notification__icon relative " :class="{ 'header-notification__icon-selected' : true }" 
                                @click="toggleNotificationWrapper">
                                <div v-if="isShowNotificationDot" class="header-notification__icon-dot"></div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="header-notification__icon relative" :class="{ 'header-notification__icon-selected' : isShowNotificationWrapper || isShowNotificationSelected, 'pe-none': isShowNotificationSelected }" 
                                @click="toggleNotificationWrapper">
                                <div v-if="isShowNotificationDot" class="header-notification__icon-dot"></div>
                            </div>
                            <div class="header-notification__wrapper" :class="{ 'selected' : isShowNotificationWrapper}">
                                <NotificationNew :showNewNotification=showNewNotification @emitNewNotificationEvent="listenNewNotificationEvent"/>
                                <div id="headerNotificationId" class="header-notification__container scrollbar-default"  @scroll="handleScrollContent($event)" ref="notificationRef">
                                    <div class="header-notification__header">
                                        <router-link :to="{ name: 'notification' }" class="header-notification__header-right-text">{{ $t('SEE_ALL') }}</router-link>
                                    </div>
                                    <NotificationList ref="notificationListRef" @emitNotificationListEvent="listenNotificationListEvent"  pageFrom="headerPage"/>
                                </div>
                            </div>
                        </template>
                    </div> -->

                    <template v-if="displayHeaderDownloadIcon && !isMobile">
                        <DownloadIconList />
                    </template>

                    <!-- Language Selection -->
                    <div
                        v-if="!isMobile && !isLogin && !isLoginPage"
                        class="language-wrapper"
                        @mouseenter="handleShowLanguageList('enter')"
                        @mouseleave="handleShowLanguageList('leave')"
                    >
                        <div
                            class="langauge-selection__wrapper lang-icon"
                            @click="handleShowLanguageList('click')"
                        >
                            <SvgIcon
                                icon="c.header.setting.iconLanguage"
                            ></SvgIcon>
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" fill="none">
                <path d="M16 29.3327C8.63599 29.3327 2.66666 23.3633 2.66666 15.9993C2.66666 8.63535 8.63599 2.66602 16 2.66602C23.364 2.66602 29.3333 8.63535 29.3333 15.9993C29.3333 23.3633 23.364 29.3327 16 29.3327ZM12.9467 26.222C11.6312 23.4318 10.8692 20.413 10.7027 17.3327H5.41599C5.67576 19.3844 6.52566 21.3166 7.86247 22.8946C9.19929 24.4726 10.9655 25.6285 12.9467 26.222ZM13.3733 17.3327C13.5747 20.5847 14.504 23.6394 16 26.3354C17.5366 23.5682 18.4341 20.492 18.6267 17.3327H13.3733ZM26.584 17.3327H21.2973C21.1308 20.413 20.3688 23.4318 19.0533 26.222C21.0345 25.6285 22.8007 24.4726 24.1375 22.8946C25.4743 21.3166 26.3242 19.3844 26.584 17.3327ZM5.41599 14.666H10.7027C10.8692 11.5857 11.6312 8.56693 12.9467 5.77668C10.9655 6.37016 9.19929 7.52608 7.86247 9.10408C6.52566 10.6821 5.67576 12.6143 5.41599 14.666ZM13.3747 14.666H18.6253C18.4332 11.5068 17.5362 8.43064 16 5.66335C14.4634 8.43053 13.5658 11.5067 13.3733 14.666M19.052 5.77668C20.3679 8.56684 21.1304 11.5856 21.2973 14.666H26.584C26.3242 12.6143 25.4743 10.6821 24.1375 9.10408C22.8007 7.52608 21.0345 6.37016 19.0533 5.77668" fill="#121416"/>
              </svg> -->
                            <!-- <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9 18C7.77 18 6.6075 17.7636 5.5125 17.2908C4.4175 16.818 3.4611 16.173 2.6433 15.3558C1.8261 14.5386 1.1811 13.5825 0.708301 12.4875C0.235501 11.3925 -0.000598859 10.23 1.14068e-06 9C1.14068e-06 7.755 0.236401 6.5886 0.709201 5.5008C1.182 4.413 1.827 3.4608 2.6442 2.6442C3.4614 1.8264 4.4172 1.1814 5.5116 0.7092C6.606 0.237 7.7688 0.0006 9 0C10.245 0 11.4114 0.2364 12.4992 0.7092C13.587 1.182 14.5392 1.827 15.3558 2.6442C16.1736 3.4614 16.8186 4.4139 17.2908 5.5017C17.763 6.5895 17.9994 7.7556 18 9C18 10.23 17.7636 11.3925 17.2908 12.4875C16.818 13.5825 16.173 14.5389 15.3558 15.3567C14.5386 16.1739 13.5861 16.8189 12.4983 17.2917C11.4105 17.7645 10.2444 18.0006 9 18ZM9 16.155C9.39 15.615 9.7275 15.0525 10.0125 14.4675C10.2975 13.8825 10.53 13.26 10.71 12.6H7.29C7.47 13.26 7.7025 13.8825 7.9875 14.4675C8.2725 15.0525 8.61 15.615 9 16.155ZM6.66 15.795C6.39 15.3 6.1536 14.7861 5.9508 14.2533C5.748 13.7205 5.5794 13.1694 5.445 12.6H2.79C3.225 13.35 3.7689 14.0025 4.4217 14.5575C5.0745 15.1125 5.8206 15.525 6.66 15.795ZM11.34 15.795C12.18 15.525 12.9264 15.1125 13.5792 14.5575C14.232 14.0025 14.7756 13.35 15.21 12.6H12.555C12.42 13.17 12.2514 13.7214 12.0492 14.2542C11.847 14.787 11.6106 15.3006 11.34 15.795ZM2.025 10.8H5.085C5.04 10.5 5.0061 10.2036 4.9833 9.9108C4.9605 9.618 4.9494 9.3144 4.95 9C4.95 8.685 4.9614 8.3814 4.9842 8.0892C5.007 7.797 5.0406 7.5006 5.085 7.2H2.025C1.95 7.5 1.8936 7.7964 1.8558 8.0892C1.818 8.382 1.7994 8.6856 1.8 9C1.8 9.315 1.8189 9.6186 1.8567 9.9108C1.8945 10.203 1.9506 10.4994 2.025 10.8ZM6.885 10.8H11.115C11.16 10.5 11.1939 10.2036 11.2167 9.9108C11.2395 9.618 11.2506 9.3144 11.25 9C11.25 8.685 11.2386 8.3814 11.2158 8.0892C11.193 7.797 11.1594 7.5006 11.115 7.2H6.885C6.84 7.5 6.8061 7.7964 6.7833 8.0892C6.7605 8.382 6.7494 8.6856 6.75 9C6.75 9.315 6.7614 9.6186 6.7842 9.9108C6.807 10.203 6.8406 10.4994 6.885 10.8ZM12.915 10.8H15.975C16.05 10.5 16.1064 10.2036 16.1442 9.9108C16.182 9.618 16.2006 9.3144 16.2 9C16.2 8.685 16.1811 8.3814 16.1433 8.0892C16.1055 7.797 16.0494 7.5006 15.975 7.2H12.915C12.96 7.5 12.9939 7.7964 13.0167 8.0892C13.0395 8.382 13.0506 8.6856 13.05 9C13.05 9.315 13.0386 9.6186 13.0158 9.9108C12.993 10.203 12.9594 10.4994 12.915 10.8ZM12.555 5.4H15.21C14.775 4.65 14.2314 3.9975 13.5792 3.4425C12.927 2.8875 12.1806 2.475 11.34 2.205C11.61 2.7 11.8464 3.2139 12.0492 3.7467C12.252 4.2795 12.4206 4.8306 12.555 5.4ZM7.29 5.4H10.71C10.53 4.74 10.2975 4.1175 10.0125 3.5325C9.7275 2.9475 9.39 2.385 9 1.845C8.61 2.385 8.2725 2.9475 7.9875 3.5325C7.7025 4.1175 7.47 4.74 7.29 5.4ZM2.79 5.4H5.445C5.58 4.83 5.7489 4.2786 5.9517 3.7458C6.1545 3.213 6.3906 2.6994 6.66 2.205C5.82 2.475 5.0736 2.8875 4.4208 3.4425C3.768 3.9975 3.2244 4.65 2.79 5.4Z" fill="white"/>
						</svg> -->
                            <!-- <div class="header-language__list-caret" :class="{ active: isShowLanguageList }">
							<svg class="down-arrow" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M1.73993 2.52026e-07L6.5345 4.58L11.3291 1.89288e-06L12.8019 1.41L6.5345 7.41L0.26709 1.41L1.73993 2.52026e-07Z" fill="white"/>
							</svg>
						</div> -->
                        </div>

                        <!-- countryBasedLangObjList -->
                        <div
                            class="language-list__wrapper"
                            :class="{ selected: isShowLanguageList }"
                        >
                            <div
                                class="language-list__container"
                                v-for="(o, index) in visitorLangList"
                                :key="index"
                                :class="{ selected: o.selected }"
                                @click="handleLanguage(o)"
                            >
                                <div class="language-list__name">
                                    <!-- <img class="img-contain language-list__name-icon" :src="require(`../../static/images/flags/${o.icon}.png`)"/> -->
                                    <span>{{ o.displayName }}</span>
                                </div>
                                <SvgIcon
                                    icon="c.team.tick"
                                    v-if="o.selected"
                                ></SvgIcon>
                                <!-- <div
                  class="language-list__tick"
                  :class="{ selected: o.selected }"
                ></div> -->
                            </div>
                        </div>
                    </div>

                    <!-- login signup -->
                    <Setting
                        v-if="!isMobile || (isMobile && isLogin)"
                        :isLoginPage="isLoginPage"
                        @updateWebNewsLang="updateWebNewsLang"
                    >
                    </Setting>

                    <!-- Avatar icon -->
                    <!-- <Setting v-if="!isMobile || (isMobile && isLogin)"></Setting> -->
                    <!-- <Setting v-if="!isMobile || (!isMobile && isLogin)"></Setting> -->
                    <!-- <div class="avatar-icon" v-if="!isMobile">
					<img src="../../static/images/icons/aspn_icon/icon_avatar_menu.png" class="avatar-icon-menu" />
					<img src="../../static/images/icons/aspn_icon/icon_avatar.png" class="avatar-icon-img" />
				</div> -->

                    <router-link
                        :to="{ name: 'account' }"
                        v-if="isMobile && !isLogin"
                        class="mobile-default-avatar-wrapper"
                    >
                        <div class="mobile-default-avatar">
                            <svg
                                width="20"
                                height="22"
                                viewBox="0 0 22 23"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M13.9365 8.51986C14.2639 8.49972 14.6328 8.0658 14.8031 7.46709C14.9942 6.79698 14.8655 6.17814 14.5155 6.08476C14.4947 6.07927 14.4739 6.07561 14.4512 6.07378C14.5023 5.57944 14.5231 5.1803 14.5325 5.00453C14.6025 3.7522 13.7208 2.83308 12.7218 2.23804C12.1125 1.87552 11.8004 1.68511 11.3198 1.63751C11.3727 1.55145 11.4087 1.10838 11.4087 0.830078C11.0227 1.22921 10.5762 1.40498 10.4399 1.43428C10.0331 1.52399 9.59607 1.95242 9.04358 2.26917C7.93482 2.90815 7.21582 3.78881 7.3161 5.13636C7.32556 5.26086 7.33124 5.62155 7.3634 6.08659C7.29718 6.07012 7.23285 6.06829 7.1723 6.08476C6.82227 6.17814 6.69171 6.79881 6.88471 7.46709C7.07202 8.12073 7.49396 8.57845 7.84021 8.51437C7.93671 8.74323 8.05213 8.94829 8.18836 9.11124C8.56299 9.55615 8.36432 10.0578 8.38513 10.6913C8.39838 11.085 8.38324 11.409 8.38892 11.5335C8.26404 11.6708 7.83832 11.907 7.63587 11.9949C8.33594 13.2234 9.18927 14.2433 10.457 14.8603C10.7238 14.9903 11.1362 15.08 11.3784 14.972C12.7672 14.3531 13.8135 13.3846 14.3849 11.9986C14.0557 11.8594 13.7833 11.7441 13.5222 11.6342C13.5222 11.2882 13.507 11.0172 13.5203 10.7444C13.5562 9.95163 13.3424 9.50489 13.5978 9.16068C13.7284 8.98491 13.84 8.7652 13.9365 8.51986Z"
                                    fill="#CFD9DE"
                                />
                                <path
                                    d="M11.123 22.6251C15.1721 22.6251 18.7878 20.8345 21.1719 18.0259C21.0508 15.2264 18.8257 14.2249 16.839 13.0477C16.2354 12.6906 15.5637 12.438 14.8485 12.1011C14.7123 12.3592 14.5798 12.6101 14.4493 12.8591C16.1049 13.8899 17.9951 14.5179 19.1265 16.2133C19.0262 16.1931 18.9089 16.2005 18.8295 16.1492C17.4615 15.2704 16.0935 14.3934 14.7388 13.4981C14.3055 13.2124 14.0255 13.2967 13.7435 13.705C13.5562 13.9778 13.3046 14.2213 13.0397 14.4282C11.2725 15.8105 10.4835 15.7611 8.83356 14.2121C8.51947 13.9173 8.17511 13.6537 7.68695 13.2417C6.19788 14.1517 4.57825 15.1404 2.95673 16.1309C4.06738 14.4904 5.99921 13.9173 7.61505 12.8536C7.49585 12.6119 7.38043 12.3739 7.21204 12.026C4.6123 13.5072 1.42603 14.2762 0.828125 17.7238C3.20648 20.7045 6.93201 22.6251 11.123 22.6251Z"
                                    fill="#CFD9DE"
                                />
                            </svg>
                        </div>
                    </router-link>
                </div>
            </div>

            <!-- sub nav -->
            <!--  -->
            <div
                class="home-nav__container display-flex-sb"
                v-if="
                    ['news', 'latestNews', 'competitionNews'].includes(
                        $route.name
                    )
                "
            >
                <div class="w-100 display-flex">
                    <router-link
                        :to="{ path: `/${currentLocale}${o.path}` }"
                        class="home-nav__child relative"
                        :class="{
                            selected: true,
                            'font-l': currentLocale === 'th',
                        }"
                        v-for="(o, index) in headerTabs"
                        :key="index"
                    >
                        <div @click="(event) => handleSubNaviMenu(o, event)">
                            <div class="display-flex-center">
                                <HeaderMenuIcon
                                    :pathName="o.pathName"
                                    :selected="true"
                                ></HeaderMenuIcon>
                                <span>{{ $t(o.name) }}</span>
                            </div>
                            <div v-if="o.isLive" class="dot-wrapper">
                                <div class="ripple"></div>
                            </div>
                        </div>
                    </router-link>
                </div>
                <div
                    class="flex-shrink-0"
                    v-if="
                        ['news', 'latestNews', 'competitionNews'].includes(
                            $route.name
                        )
                    "
                >
                    <div
                        class="news-language__selection-wrapper"
                        v-if="
                            !isMobileRealTime &&
                            newsLangSelect.selectedLangObj !== null
                        "
                        @mouseover="handleShowNewsLanguagelist('enter')"
                        @mouseleave="handleShowNewsLanguagelist('leave')"
                    >
                        <div
                            class="news-language__selected-pill btn-aspn-only-default 1"
                        >
                            <div class="news-language__selected-name">
                                {{ newsLangSelect.selectedLangObj.displayName }}
                            </div>
                            <div
                                class="news-language__list-caret"
                                :class="{ active: newsLangSelect.isShowList }"
                            >
                                <SvgIcon icon="c.header.newsCaret" />
                            </div>
                        </div>
                        <div
                            class="news-language-list__wrapper"
                            :class="{ active: newsLangSelect.isShowList }"
                        >
                            <div
                                class="news-language-list__container"
                                v-for="(o, index) in currentLanguageList"
                                :key="index"
                                :class="{
                                    selected:
                                        o.locale ===
                                        newsLangSelect.selectedLangObj.locale,
                                }"
                                @click="handleNewsLangSelect(o)"
                            >
                                <div class="news-language-list__name">
                                    {{ o.displayName }}
                                </div>
                                <SvgIcon
                                    icon="c.team.tick"
                                    v-if="
                                        o.locale ===
                                        newsLangSelect.selectedLangObj.locale
                                    "
                                ></SvgIcon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <FavLoginTips ref="favLoginTipsRef"></FavLoginTips> -->
    <ModalFav
        @closeModal="toggleFavModal"
        @favModelEmit="toggleFavModalList"
        :tabName="isTab"
    />
    <ModalBasketballFav
        @closeModal="toggleBasketballFavModal"
        @favModelEmit="toggleFavModalList"
        :tabName="isTab"
    />
    <PopUpSignInIndexMobile
        ref="PopUpSignInIndexMobileRef"
        :title="$i18n.t('FAV_LOGIN_TITLE')"
        :message="$i18n.t('FAV_LOGIN_TIPS')"
        class="login-fav-popup"
    ></PopUpSignInIndexMobile>
</template>

<script>
import Setting from "@/components/header/Setting.vue";
import MainLogo from "@/components/indicator/MainLogo.vue";
import HeaderMenuIcon from "@/components/ui/HeaderMenuIcon.vue";

import APPDownloadHomePage from "@/components/mobile/app/APPDownloadHomePage.vue";

import NotificationList from "@/views/notifications/components/List.vue";
import NotificationNew from "@/views/notifications/components/New.vue";

import ModalFav from "@/views/fav/components/Modal.vue";
import ModalBasketballFav from "@/views/fav/components/BasketballModal.vue";

import FavLoginTips from "@/components/favourite/TipsLogin.vue";
import HeaderAppBanner from "@/components/modal/HeaderAppBanner.vue";

import PopUpSignInIndexMobile from "@/components/user/PopUpSignInIndexMobile.vue";

import DownloadIconList from "@/components/socialMediaSharing/DownloadIconList.vue";
import config from "../js/config";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
    components: {
        Setting,
        MainLogo,
        HeaderMenuIcon,
        APPDownloadHomePage,
        FavLoginTips,
        ModalFav,
        ModalBasketballFav,
        PopUpSignInIndexMobile,
        NotificationList,
        HeaderAppBanner,
        NotificationNew,
        DownloadIconList,
    },
    data() {
        return {
            isShowLanguageList: false,
            isTab: "FILTER",

            isShowNotification: false,
            isShowNotificationDot: false,
            isShowNotificationWrapper: false,
            isShowNotificationSelected: false,

            showNewNotification: false,

            returnAPIData: {
                isFinishLoad: false,
                hasNext: true,
            },

            visitorLangList: [],
            newsLangSelect: {
                selectedLangObj: null,
                isShowList: false,
                msInstance: null,
            },
            displayHeaderDownloadIcon: config.headerDownloadIcon,
        };
    },
    props: {
        isLoginPage: Boolean,
    },
    computed: {
        ...mapGetters([
            "isShowHeader",
            "isShowAppDownloadHome",
            "currentLocale",
            "currentLanguageList",
            "currentLanguageObj",
            "currentCountryObj",
            "headerTabs",
            "aspnHeaderTabs",
            "currentSubNavimenu",
            "currentSportType",
            "isMobile",
            "isLogin",
            "userInfo",
            "hasNewNotification",
            "newNotificationData",
            "currentCountryList",
            "isMobileRealTime",
            // "userLangConfig",
            // "userSelectedLangConfigObj",
        ]),
    },
    watch: {
        $route: {
            deep: true,
            handler(newVal, oldVal) {
                this.initSelectedTab();
                this.isShowNotificationWrapper = false;
                this.verifyIsAtNotificationPage();
                if (newVal) {
                }
                this.handleHighlightMenus();
            },
        },
        isShowNotificationDot: {
            deep: true,
            handler(newVal, oldVal) {},
        },
        isLogin: {
            deep: true,
            handler(newVal, oldVal) {
                this.verifyToShowNotification();
                if (!newVal) {
                    this.setLangList();
                }
            },
        },
        hasNewNotification: {
            deep: true,
            handler(newVal, oldVal) {
                this.isShowNotificationDot = newVal;
                if (newVal) {
                    if (this.isShowNotificationWrapper) {
                        this.showNewNotification = true;
                    }
                } else {
                    this.showNewNotification = newVal;
                }
            },
        },
    },
    mounted() {
        this.initSelectedTab();
        this.setLangList();
        this.verifyToShowNotification();
        this.verifyIsAtNotificationPage();
        document.addEventListener("click", this.documentClick);
        this.$nextTick(() => this.handleHighlightMenus());
        if (!this.isMobile) {
            let locale = localStorage.getItem("newsLang");
            if (locale) {
                this.setSelectedNewsLang(JSON.parse(locale));
            } else {
                this.setSelectedNewsLang();
            }
        }
    },
    methods: {
        ...mapMutations([
            "UPDATE_USER_LANG_CONFIG",
            "CURRENT_SUB_NAVI_MENU_CHANGE",
            "SET_SELECTED_SUB_NAVI_MENU",
            "CLEAR_SELECTED_SUB_NAVI_MENU",
            "SET_NEWS_LANG_SELECTED",
        ]),
        ...mapActions([
            "currentLocaleChangeEvent",
            "postUpdateProfilePreferredLanguage",
            "getRetrieveUserInfo",
            "favLoginTipsChangeEvent",
            "toggleFavModal",
            "toggleBasketballFavModal",
            "toggleFavModalList",
            "getNotificationNotified",
            "setUserData",
            "toggleNewNotification",
            "getCountryCodeByIp",
            "currentCountryChangeEvent",
        ]),

        async setLangList() {
            const user = localStorage.getItem("user");
            let countryCode;
            if (user === null) {
                // && !this.currentCountryObj
                let result = await this.getCountryCodeByIp();
                countryCode = result.result.countryCode;
                if (result.message === "Success") {
                    this.currentCountryChangeEvent(countryCode);
                }
                let supportedLocaleList = this.currentCountryList.filter(
                    (x) => x.countryCode === countryCode
                )[0]?.supportedLocale;
                this.visitorLangList = [];
                if (typeof supportedLocaleList === "undefined") {
                    this.currentLanguageList.forEach((obj) => {
                        if (obj.displayLocale === "en") {
                            obj.selected = true;
                            this.visitorLangList.push(obj);
                        }
                    });
                } else {
                    supportedLocaleList.forEach((locale) => {
                        this.currentLanguageList.forEach((obj) => {
                            if (obj.displayLocale === locale) {
                                obj.selected =
                                    obj.displayLocale === this.currentLocale
                                        ? true
                                        : false;
                                this.visitorLangList.push(obj);
                            }
                        });
                    });
                }
            }
        },

        handleShowLanguageList(action) {
            if (action === "enter" && !this.isMobile) {
                //ingnore mobile touch event
                this.isShowLanguageList = true;
            } else if (action === "click") {
                this.isShowLanguageList = !this.isShowLanguageList;
            } else {
                this.isShowLanguageList = false;
            }
        },

        handleLanguage(o) {
            this.currentLocaleChangeEvent(o.displayLocale);

            this.UPDATE_USER_LANG_CONFIG(o.displayLocale);
            localStorage.setItem("newsLang", JSON.stringify(o));
            this.updateWebNewsLang(o);
        },

        handleHighlightMenus() {
            for (let i = 0; i < this.headerTabs.length; i++) {
                if (
                    this.headerTabs[i].pathName === this.$route.name ||
                    this.headerTabs[i].pathName ===
                        this.$route.meta.highlightMenu
                ) {
                    this.handleSubNaviMenu(this.headerTabs[i]);

                    this.highlightSubMenuBasedOnChildPage();
                }
            }
        },

        highlightSubMenuBasedOnChildPage() {
            let group = [
                "eventDetail",
                "highlightsDetail",
                "leaguePage",
                "match detail",
                "teamPage",
                "playerPage",
                "basketballFantasysport",
            ];
            if (
                this.$route.meta.highlightSubMenu &&
                group.includes(this.$route.meta.category)
            ) {
                this.SET_SELECTED_SUB_NAVI_MENU(
                    this.$route.meta.highlightSubMenu
                );
            }
        },

        handleSubNaviMenu(o, event) {
            // event.preventDefault();
            this.CLEAR_SELECTED_SUB_NAVI_MENU();
            this.CURRENT_SUB_NAVI_MENU_CHANGE(o);
        },

        handleHeaderTabsRedirect(o, event) {
            this.CLEAR_SELECTED_SUB_NAVI_MENU();
            if (o.name === "FAVOURITES" || o.name === "FANTASY_SPORT") {
                if (!this.isLogin) {
                    event.preventDefault();
                    if (o.name === "FANTASY_SPORT") {
                        this.favLoginTipsChangeEvent({
                            isOpen: true,
                            event: event,
                            type: "top",
                            message: "FANTASY_SPORT_LOGIN_TIPS",
                        });
                    } else {
                        this.favLoginTipsChangeEvent({
                            isOpen: true,
                            event: event,
                            type: "top",
                        });
                    }
                }
            }
        },

        handleRedirect(type) {
            if (type === "FAVOURITES") {
                let favouritePathName;
                if (this.currentSportType === "football")
                    favouritePathName = "footballFavourites";
                else if (this.currentSportType === "basketball")
                    favouritePathName = "basketballFavourites";
                this.$router.push({ name: favouritePathName });
            }
        },

        toggleGlobalSearchModal() {
            if (this.currentSportType === "football") {
                this.toggleFavModal();
            } else {
                this.toggleBasketballFavModal();
            }
            // if (this.isLogin) {
            // 	this.toggleFavModal()
            // } else {
            // 	this.$refs.PopUpSignInIndexMobileRef.handleOpen();
            // }
        },

        toggleFavouriteModal() {
            if (this.isLogin) {
                this.handleRedirect("FAVOURITES");
            } else {
                // if (this.isLogin) {
                // 	this.handleRedirect('FAVOURITES')
                // } else {
                this.$refs.PopUpSignInIndexMobileRef.handleOpen();
                // }
            }
        },

        async verifyToShowNotification() {
            if (this.isLogin) {
                await this.getRetrieveUserInfoData();
                this.isShowNotification = true;
                this.isShowNotificationDot = this.userInfo.notificationFlag;
            } else {
                this.isShowNotification = false;
            }
        },

        verifyIsAtNotificationPage() {
            if (this.$route.name === "notification") {
                this.isShowNotificationSelected = true;
                this.isShowNotificationWrapper = false;
            } else {
                this.isShowNotificationSelected = false;
            }
        },

        documentClick(e) {
            this.isShowNotificationWrapper = false;
            e.stopPropagation();
        },

        async toggleNotificationWrapper(e) {
            if (this.isMobile) {
                this.isShowNotificationDot = false;
                this.toggleNewNotification(false);

                this.$router.push({ name: "notification" });
            } else {
                if (this.$route.name !== "notification") {
                    e.stopPropagation();
                    this.isShowNotificationWrapper =
                        !this.isShowNotificationWrapper;

                    //if the notification list is open
                    if (this.isShowNotificationWrapper) {
                        if (this.isShowNotificationDot) {
                            await this.getNotificationNotified();
                            this.verifyToShowNotification();
                        }
                        this.toggleNewNotification(false);
                        this.$refs.notificationListRef.init();
                    } else {
                        if (this.showNewNotification) {
                            this.showNewNotification = false;
                        } else {
                            const result = await this.getNotificationNotified();
                            await this.getRetrieveUserInfoData();
                        }
                    }
                }
            }
        },
        // get user info
        async getRetrieveUserInfoData() {
            let params = {
                token: this.userInfo.token,
                timeZone: this.$tools.getCurrentTimeZone(),
            };

            const result = await this.getRetrieveUserInfo(params);
            this.setUserData(result.result.data);
        },

        listenNotificationListEvent(params) {
            this.returnAPIData = params;
        },

        listenNewNotificationEvent(event) {
            this.$refs.notificationRef.scrollTo(0, 0);
            this.$refs.notificationListRef.init();

            this.toggleNewNotification();
            event.stopPropagation();
        },

        handleScrollContent(event) {
            let element = event.currentTarget;

            if (
                element.scrollTop + element.offsetHeight + 2 >=
                    element.scrollHeight &&
                this.returnAPIData.hasNext
            ) {
                this.$refs.notificationListRef.loadMorePosts();
            }
        },
        initSelectedTab() {
            this.aspnHeaderTabs.forEach((e) => {
                e.pathSelected.includes(this.$route.name)
                    ? (e.selected = true)
                    : (e.selected = false);
            });
        },
        handleSelectTab(o, aspnHeaderTabs) {
            aspnHeaderTabs.forEach((e) => {
                e.selected = false;
            });
            o.selected = true;
        },
        handleShowNewsLanguagelist(action) {
            if (action === "enter") {
                this.newsLangSelect.isShowList = true;
            } else {
                this.newsLangSelect.isShowList = false;
            }
        },
        updateWebNewsLang(o) {
            this.handleNewsLangSelect(o);
        },
        handleNewsLangSelect(o) {
            this.newsLangSelect.isShowList = false;
            this.setSelectedNewsLang(o);
        },

        setSelectedNewsLang(o = null) {
            if (o === null) {
                //this.newsLangSelect.selectedLangObj
                this.newsLangSelect.selectedLangObj = this.currentLanguageObj;
            } else {
                this.newsLangSelect.selectedLangObj = o;
            }
            this.SET_NEWS_LANG_SELECTED(this.newsLangSelect.selectedLangObj);
        },
        handleClickTabBeforeRouter(o) {
            if ((o.isLogin === true && this.isLogin) || !o.isLogin) {
                this.handleSelectTab(o, this.aspnHeaderTabs);
                this.$router.push(`/${this.currentLocale}${o.path}`);
            } else {
                this.$refs.PopUpSignInIndexMobileRef.handleOpen();

                // this.favLoginTipsChangeEvent({isOpen: true, event: event, type: 'top'})
            }
            return;
        },
    },
};
</script>

<style scoped>
.py20 {
    padding: 20px 0;
}
.py7 {
    padding: 7px 0;
}
.home-nav__match-wrapper {
    padding-top: 0;
    padding-bottom: 0;
}
@media(max-width: 1200px) {
    .home-nav__match-wrapper .container {
        margin: 0;
    }
}
.language-wrapper {
    position: relative;
    z-index: 4;
    flex: 1;
}
.langauge-selection__wrapper {
    width: 3.5rem;
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
}
/* PHASE 2 */
.langauge-selection,
.mobile-default-avatar-wrapper {
    position: relative;
    width: 1.8rem;
    height: 1.8rem;
    border-radius: 50%;
    padding: 0.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--color-grey-60);
    cursor: pointer;
    display: none;
}
.langauge-selection:hover,
.mobile-default-avatar-wrapper:hover {
    background-color: var(--color-grey-40);
}
.language-list__wrapper {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 0.413rem; /*0.1rem;*/
    min-width: 12rem;
    background-color: var(--color-background-default-secondary);
    padding: 0.5rem 0.3rem; /*0.5rem 0.3rem*/
    border-radius: 0.5rem;
    transform: scale(0);
    transform-origin: 11.5rem 0%;
    transition: all 0.3s;
    border: 1px solid var(--color-border-default-default);
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.08), 0 0 4px 0 rgba(0, 0, 0, 0.25),
        0 0 24px 0 rgba(0, 0, 0, 0.16);
}
.language-list__wrapper.selected {
    /* transform-origin: 11.5rem 0%; */
    transform: scale(1);
}
.language-list__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.5rem; /*0.3rem 0.5rem*/
    margin-bottom: 0.375rem;
    cursor: pointer;
    transition: all 0.3s;
    height: 40px;
}
.language-list__container:last-child {
    margin-bottom: 0;
}
.language-list__container:hover {
    background-color: var(--color-background-default-default-hover);
    border-radius: 0.4rem;
}
.language-list__container.selected {
    background-color: var(--color-background-default-tertiary-hover);
    border-radius: 0.4rem;
    color: var(--color-text-default-default);
}
.language-list__name {
    display: flex;
    align-items: center;
    font-size: 0.88rem;
    color: var(--color-text-default-default);
}
.language-list__container.selected .language-list__name {
    color: var(--color-text-default-default);
}
.language-list__name-icon {
    object-fit: contain;
    margin-right: 0.7rem;
    width: 1.5rem;
    height: 1.5rem;
}
.language-list__tick {
    width: 1rem;
    height: 1rem;
}
.language-list__tick.selected {
    background: url("../../static/images/icons/icon_tick_selected.png")
        center/cover no-repeat;
}
.language-list__tick img {
    object-fit: contain;
    width: 100%;
    height: 100%;
}
.mobile-default-avatar-wrapper .mobile-default-avatar {
    background-color: #000000;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.header-right__wrapper {
    gap: 1.375rem;
    /* padding-right: 1rem; */
}
/* notification */
.header-notification-icon__wrapper {
    margin-right: 1rem;
    position: relative;
}
.header-notification__wrapper {
    position: absolute;
    right: -4rem;
    min-width: 12rem;
    background-color: var(--color-grey-20);
    border-radius: 0.5rem;
    transform: scale(0);
    transform-origin: 18.5rem 0%;
    transition: all 0.3s;
    top: 2.5rem;
    z-index: 1;
    width: 371px;
    height: 472px;
    cursor: auto;
    overflow-y: hidden;
    overflow-x: hidden;
    box-sizing: border-box;
    box-shadow: 1px 1px 4px 2px #12181b;
    padding: 0.15rem 0;
}
.header-notification__container {
    overflow-y: auto;
    height: inherit;
}
.header-notification__wrapper.selected {
    transform: scale(1);
}
.header-notification__header {
    display: flex;
    justify-content: flex-end;
    padding-right: 1rem;
    padding-top: 0.85rem;
}
.header-notification__header-right-text {
    color: var(--bg-selected);
    font-size: 0.875rem;
}
.header-notification__icon {
    background: url(../../static/images/icons/icon_notification_grey.png)
        center/contain no-repeat;
    width: 16px;
    height: 19.5px;
    cursor: pointer;
}
.header-notification__icon:hover {
    background: url(../../static/images/icons/icon_notification_selected.png)
        center/contain no-repeat;
}
.header-notification__icon-selected {
    background: url(../../static/images/icons/icon_notification_selected.png)
        center/contain no-repeat;
}
.header-notification__icon-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    box-sizing: border-box;
    border: 3px solid black;
    position: absolute;
    background-color: #ff220c;
    bottom: -2px;
    right: -4px;
}
/* header language selection */
.header-language__list-caret {
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
    transition: all 0.3s;
}
.header-language__list-caret.active {
    transform: rotateX(180deg);
}
.search-icon-webapp {
    width: 40px;
    height: 40px;
}
.lang-icon {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    background-color: var(--color-background-default-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.lang-icon:hover {
    background-color: var(--color-background-default-secondary-hover);
}
@media(max-width: 768px) {
    /* for test */
    .language-wrapper,
    .mobile-default-avatar-wrapper {
        /* right: 1rem; */
    }
    .header-notification-icon__wrapper {
        margin-right: 0;
    }

    .header-right__wrapper {
        gap: 0.5rem;
    }
    .py20 {
        padding: 12px 0 8px;
    }
}
</style>

<style scoped>
.flex-shrink-0 {
    flex-shrink: 0;
}
.news-language__selection-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    /* border: 1px solid  var(--color-border-default-default); */
    border-radius: 24px;
}
.news-language__selected-pill {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* max-width: 7.3rem; */
    box-sizing: border-box;
    width: 100%;
    /* border: 1px solid var(--color-border-default-default); */
    border-radius: 24px;
    padding: 8px 16px 8px 24px;
    font-size: 16px;
    font-family: var(--weight-600);
    background-color: var(--color-background-default-secondary);
    color: var(--color-text-default-default);
    cursor: pointer;
}
.news-language__selected-pill .news-language__list-caret {
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
    transition: all 0.3s;
}
.news-language__selected-pill .news-language__list-caret.active {
    transform: rotateX(180deg);
}
.news-language-list__wrapper {
    position: absolute;
    top: 100%;
    z-index: 2;
    background: var(--color-background-default-secondary);
    border-radius: 0.7rem;
    min-width: 12.5rem;
    transform: scale(0);
    transform-origin: 100% 0;
    transition: all 0.3s;
    padding: 0.5rem;
    border: 1px solid var(--color-border-default-default);
}
.news-language-list__wrapper.active {
    transform: scale(1);
}
.news-language-list__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    margin-bottom: 0.375rem;
    border-radius: 0.3rem;
    cursor: pointer;
    color: var(--color-text-default-default);
    font-size: 16px;
    font-family: var(--weight-600);
}
.news-language-list__container:last-child {
    margin-bottom: 0;
}
.news-language-list__container:hover,
.news-language-list__container.selected {
    background: var(--color-background-default-tertiary-hover);
    /* color: var(--color-button-active) !important; */
}
.news-language-list__name {
    font-size: 16px;
    font-family: var(--weight-600);
}
.news-language-list__tick {
    width: 1rem;
    height: 1rem;
}
.news-language-list__tick.selected {
    background: url("../../static/images/icons/icon_tick_selected.png")
        center/cover no-repeat;
    background-size: 12px 10px;
}
.logo-wrapper {
    padding-right: 163px;
}
.profile-icon-wrapper {
    padding-left: 0;
}
@media(max-width: 768px) {
    /* for test */
    .profile-icon-wrapper {
        padding-left: 0;
    }
    .logo-wrapper {
        padding-right: 0;
    }
}
</style>
